import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
// import En from '../../Icons/LangFlags/En';
// import Ua from '../../Icons/LangFlags/Ua';
// import Ru from '../../Icons/LangFlags/Ru';
import styles from './HeaderSmall.module.css';
// import LangSelector from '../LangSelector/LangSelector';
import { Link } from 'react-router-dom';
import NavMenu from '../NavMenu/NavMenu';
import { useTranslation } from 'react-i18next';

const HeaderSmall = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  // const [selectedLang, setSelectedLang] = useState('English');

  // const handleLangSelect = (lang) => {
  //   setSelectedLang(lang);
  // };
  const { t } = useTranslation();

  const handleBurgerClick = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add(styles['no-scroll']);
    } else {
      document.body.classList.remove(styles['no-scroll']);
    }

    // Cleanup the effect
    return () => {
      document.body.classList.remove(styles['no-scroll']);
    };
  }, [menuOpen]);

  // useEffect(() => {
  //   const lng = navigator.language;

  //   i18n.changeLanguage(lng);
  // }, []);

  return (
    <header role='banner'>
      {/* <header className={styles.mobileMenuContainer} role="banner"> */}
      <div className={styles.mobileMenuContainer}>
        <h1>
          <Link to='/'>{t('lang.homeTitle')}</Link>
        </h1>
        <div className={styles.burger__container}>
          <div
            id='burgerIcon2'
            className={`burgerBtn ${styles.burgerBtn} ${
              menuOpen ? styles.open : ''
            }`}
            onClick={handleBurgerClick}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      {/* <div className={styles.textContainer}>
        <p>{t('lang.homeTitle2')}</p>
      </div> */}

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            id='menu'
            className={styles['mobile__menu-container']}
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            transition={{ duration: 0.5 }}
            exit={{ x: '100%' }}
          >
            <NavMenu menuSmall='1' menuOpen={setMenuOpen} />
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default HeaderSmall;
